module.exports = __webpack_public_path__ + "media/images/iconUp__okGreen--dark-4ac703872cea43b1c3f5eda58c36639f.png";